import React from 'react';
import { FallBackScreenProps } from '@zonofi/zono-money-helpers';
import './fallback-screen.scss';

export const FallBackScreen: React.FC<FallBackScreenProps> = ({
  image,
  message,
  description,
  buttonName,
  onButtonClick,
  contentStyle,
}) => {
  return (
    <div className="fallback-screen-container">
      <div className="fallback-content" style={{ ...contentStyle }}>
        <img
          className="fallback-content-img"
          src={image}
          alt="fallbackImage"
          width={'172px'}
        />

        <div className="fallback-content-body">
          <div className="fallback-content-body-message">
            <div className="font-primary-semibold fallback-content-body-message-header">
              {message}
            </div>
            <div className="font-primary fallback-content-body-message-description">
              {description}
            </div>
          </div>
          {buttonName && onButtonClick && (
            <button
              onClick={onButtonClick}
              className="fallback-content-body-button font-primary"
            >
              {buttonName}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
